<template>
  <div class="m-basket shop-basket shop-view">
    <div class="basket-header"></div>

    <div class="basket-view">
        <div class="basket-wrapper">
            <div class="user-info clearfix">
                <span class="user-name"><em v-if="$store.state.userinfo.areaId">【{{ $queryArea($store.state.userinfo.areaId) }}】</em>{{ $store.state.userinfo.name || $store.state.ua.account || '仙术师' }}</span>
                <div class="m-m3b f-r" v-if="$store.state.login">
                    <div class="m3b-info">
                        <div class="m3b-num">{{ $store.state.m3b }}</div>
                        <div class="u-btn add-m3b"><a href="https://pay.17m3.com/" target="_blank"></a></div>                                  
                    </div>
                    <div class="u-btn reflash" @click="m3bUpdate();"></div>
                </div>
            </div>

            <div class="basket-detail" v-if="$store.state.login && basket_list.length">
                <div class="basket-item" v-for="(shop,index) in basket_list" :key="index">
                    <div class="shop-detail" v-if="shop.discountName">
                        <p class="discount">{{ shop.discountName }}</p>
                    </div>
                    <div class="basket-panel">
                        <div class="basket-list-header"></div>
                        <div class="basket-list-body basket-body">
                            <div class="check-box all" 
                            v-bind:data-x="index" 
                            v-bind:sid="shop.shopId" 
                            @click="shopPickAll(shop);"
                            :class="{'act' : shop.isChecked}"
                            ></div>
                            <h6 @click="see_offer (shop.shopId)">{{ shop.shopName }}<span v-if="shop.shopId == 11">（点我查看折扣券）</span><em class="shop-guide">&gt;</em></h6>
                            <ul>
                                <li v-for="(item,k) in shop.data" :key="k">
                                    <div class="check-box" 
                                    v-bind:data-matrixx="index" 
                                    v-bind:data-matrixy="k" 
                                    @click="basketPick(item,shop);"
                                    :class="{'act':item.isChecked || shop.isChecked}"
                                    ></div>
                                    <div class="item-detail clearfix">
                                        <div class="pic f-l" 
                                        v-if="$store.state.tipsimg.indexOf(item.itemid) > -1 && item.itemid != 'J237'" 
                                        @click="$item_tips({ item_id : item.itemid + '.png',type : 'img'})">
                                        <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                        </div>                                  
                                        <div class="pic f-l" v-else 
                                        @click="$item_tips({ item_id : item.itemid})"><div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div></div>
                                        <div class="item-info f-l">
                                            <h6 class="item-name">{{ item.name }}</h6>
                                            <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.priceMin }}</span><span class="p-before">{{ item.priceBefore }}</span></div>
                                            <div class="now">当前价<em class="icon-m3b"></em><span>{{ item.priceCurrent }}</span></div>
                                        </div>
                                        <div class="u-btn apply f-r" v-if="!item.target" v-bind:data-gid="item.id" @click="calldiscountModal(item);"></div>                         
                                    </div>                                                     
                                </li>
                            </ul>                                            
                        </div>
                        <div class="basket-list-footer"></div>
                    </div>
                </div>
            </div>
            <div class="notice" v-else>
                <h5>您还没有相关订单</h5>
                <p><router-link to="/bazaar"> 可以去集市看看有没有想买的~</router-link></p>                
            </div>
        </div>
    </div>

    <recommend></recommend>

    <div class="bottom-bubble">
        <div class="txt-bubble"></div>
        <div class="u-btn u-top"></div>
    </div>      

    <calculator @basketPickAll="basketPickAll" @call_buyModal="call_buyModal" :basket_list="basket_list" :shop_offer="shop_offer" :m3b="m3b"></calculator>

    <buy-modal ref="buy" @m3bUpdate_offline="m3bUpdate_offline" @render="list_update" @basketListSort="basketListSort"></buy-modal>
  </div>
</template>

<script>
import userinfo from '@/components/userinfo.vue'
import calculator from '@/components/calculator.vue'
import recommend from '@/components/recommend.vue'
import buy from '@/components/BuyModal/buyModal.vue'

export default {
  name: 'basket',
  components : {
    'm-user': userinfo,
    'calculator' : calculator,
    'recommend' : recommend,
    'buy-modal' : buy,
  },
  data (){
    return {
      list : [],
      basket_list : [],
      pick_data : [],
      m3b : 0,
    }
  },
  props : {
    shop_offer :{
        default : () => {},
    },      
  },
  created (){
    if(!parseInt(this.$store.state.login)){
      this.$router.push('/')
      return this.$mslogin.open();
    }
    if(!this.$store.state.userinfo){
      this.$router.push('/')
      return this.$toast('请先选择大区');
    }
    this.m3b = this.$store.state.m3b ? this.$store.state.m3b : 0
    this.render();
  },
  watch : {
      list : {
        handler (val) {
            this.basket_list = this.basketListSort(val)
        },
        deep : true,         
      }
  },
  inject : ['reload'],
  methods : {
    render (){
      this.$axios.post(this.$ajax_url_map.basket)
      .then(res => {
        //this.list = res.data.list;
        if(res.code != 0)return;
        this.basket_list = this.basketListSort(res.data.list)
      }, rej => {
        this.$toast(rej.message);
      })
    },
    list_update(){
      this.reload();       
    },
    basketListSort(arr) {
        var map = {},
            dest = [];
        for (var i = 0; i < arr.length; i++) {
            var ai = arr[i];
            if (!map[ai.shopId]) {
                ai.isChecked = false;
                dest.push({
                    shopId: ai.shopId,
                    discountName: ai.discountName,
                    discountType: ai.discountType,
                    shopName: ai.shopName,
                    data: [ai],
                    isChecked : false,
                });
                map[ai.shopId] = ai;
            } else {
                for (var j = 0; j < dest.length; j++) {
                    var dj = dest[j];
                    if (dj.shopId == ai.shopId) {
                        ai.isChecked = false;
                        dj.data.push(ai);
                        break;
                    }
                }
            }
        }
        return dest;
    },
    m3bUpdate (){
      this.$axios.get(this.$ajax_url_map.m3b)
      .then(res => {
        this.$toast('梦三币刷新成功');
        this.m3b = res.data.coin
        this.m3bUpdate_offline (res.data.coin)
      },rej => {
        this.$toast(rej.message);
      })
    },
    m3bUpdate_offline (val){
        this.$store.commit("$_setm3b", val);
    },
    basketPick (item,shop){
      item.isChecked = !item.isChecked;

      var missing_flag = shop.data.filter(function(e){
          return e.isChecked == false;
      }).length

      shop.isChecked = missing_flag ? false : true;
    },
    shopPickAll(shop){
        shop.isChecked = !shop.isChecked;
        shop.data.forEach(element => {
            element.isChecked = shop.isChecked;
        });
    },
    calldiscountModal(data){
        this.$discount_detail({
            player_list : data.list,
            shareTxt : data.shareContent,
            key : data.key,
            price : data.priceMin,
        })
    },
    basketPickAll (state){
        this.basket_list.forEach(shop => {
            shop.isChecked = state;

            shop.data.forEach(item => {
                item.isChecked = state;
            })  
        });
    },
    see_offer (sid){
        this.$router.push({ name: 'offer', params: { sid: sid }});
    },
    call_buyModal(data){
        this.$refs.buy.dialogVisible = true;

        this.$refs.buy.settle = data.settle;
        this.$refs.buy.list = data.list;
        this.$refs.buy.m3b = data.m3b;
    }
  },
}
</script>

<style scoped>
/* basket */
.shop-basket {
    padding-top: 10px;
    background-image: url(~@/assets/images/body-basket.jpg);
    background-size: 750px auto;
    background-repeat: repeat-y;
}

.basket-header {
    width: 750px;
    height: 166px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/bg-order-top.png);
}

.basket-view {
    padding-bottom: 40px;
    margin-bottom: 20px;
    background:
        url(~@/assets/images/bg-order-bottom.png) center bottom no-repeat,
        url(~@/assets/images/bg-order-body.png) center top repeat-y;

    background-size: auto 64px, auto 25px;
}

.basket-wrapper {
    padding: 0 20px;
}

.basket-item {
    padding-bottom: 20px;
}

.basket-view .user-info {
    color: #dcc4b1;
}

.basket-view .user-info .user-ctrl .u-btn{
  font-size: 0;
  color: transparent;
}

.m-m3b{
  margin-top: -10px;
}

.m3b-info {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 201px;
    height: 52px;
    background-image: url(~@/assets/images/bg-m3b.png);
}

.m3b-info .u-btn.add-m3b {
    position: absolute;
    right: 0;
    top: 50%;
    width: 49px;
    height: 49px;
    background-image: url(~@/assets/images/icon-charge.png);
    transform: translateY(-50%);
}

.m3b-num {
    line-height: 52px;
    padding-left: 60px;
    color: #dcc4b1;
}

.u-btn.add-m3b a {
    display: block;
    width: 100%;
    height: 100%;
}

.u-btn.reflash {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 38px;
    height: 32px;
    margin: 0 20px 0 10px;
    background-image: url(~@/assets/images/reflesh_2.png);
}

.cost-info p {
    margin-top: 10px;
}

.cost-info .cost{
    color: #d33d27;
    font-weight: 700;
}

.cost-info .discount{
    padding: 0 15px;
}

/* basket-panel */
.basket-list-header {
    position: relative;
    width: 711px;
    height: 34px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/bg-basket-detail-top.png);
    pointer-events: none;
}

.basket-list-body {
    position: relative;
    width: 711px;
    margin: 0 auto;
    padding-left: 80px;
    background: url(~@/assets/images/bg-basket-detail-body.png) center top repeat-y;
    background-size: auto 18px;
    box-sizing: border-box;
}

.basket-list-body li {
    padding-right: 50px;
    padding-bottom: 30px;
}

.basket-body h6 {
    position: relative;
    margin-top: -12px;
    margin-bottom: 12px;
    font-size: 28px;
    font-weight: 700;
    color: #683d1e;
}

.basket-body h6 a{
    color: #683d1e;
}

.basket-detail {
    margin-top: 15px;
}

.basket-detail .discount {
    position: relative;
    margin-bottom: 18px;
    padding-left: 104px;
    color: #d33d27;
}

.basket-detail .discount::before {
    position: absolute;
    display: block;
    content: '';
    width: 74px;
    height: 38px;
    left: 0;
    top: -5px;
    background-image: url(~@/assets/images/icon-down_sp.png);
    background-size: 74px auto;
}

/*  */
.basket-list-body .check-box.all {
    position: absolute;
    left: 18px;
    top: -2px;
    width: 49px;
    height: 46px;
    background-image: url(~@/assets/images/icon-on_2.png);
}

.basket-list-body .check-box.all.act {
    /* width: 65px;
    height: 61px; */
    background-image: url(~@/assets/images/icon-on_2-act.png);
}

.basket-list-body li {
    position: relative;
}

.basket-list-body li .check-box {
    position: absolute;
    left: -58px;
    top: 40px;
    width: 40px;
    height: 37px;
    background-image: url(~@/assets/images/icon-off.png);
}

.basket-list-body li .check-box.act {
    position: absolute;
    left: -58px;
    top: 50%;
    width: 40px;
    height: 37px;
    margin-top: -30px;
    background-image: url(~@/assets/images/icon-on.png);
}

.basket-body .pic {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 113px;
    height: 112px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.basket-body .pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.basket-body .goods-detail {
    padding-top: 15px;
    padding-left: 115px;
}

.basket-body .item-info {
    margin-left: 15px;
}

.basket-body .item-name {
    margin: 0 0 5px;
    color: #683d1e;
    font-weight: 700;
}

.basket-body .low {
    color: #683d1e;
}

.basket-body .now {
    color: #683d1e;
}

.basket-body .now span {
    font-size: 28px;
    font-weight: 700;
    color: #d33d27;
}

.basket-body .p-before {
    padding-left: 8px;
    color: #ad7239;
    text-decoration: line-through;
}

.basket-body .u-btn.apply {
    position: absolute;
    right: 50px;
    top: -5px;
    width: 123px;
    height: 122px;
    /* margin: -.12rem 0 0 .95rem; */
    background-image: url(~@/assets/images/btn-apply_order.png);
}

/* end */

.basket-list-footer {
    width: 711px;
    height: 34px;
    margin: -10px auto 0;
    background-image: url(~@/assets/images/bg-basket-detail-bottom.png);
}

.basket-cntor {
    position: fixed;
    width: 750px;
    height: 134px;
    padding: 15px 15px 0 25px;
    left: 50%;
    bottom: 90px;
    background-image: url(~@/assets/images/bg-basket.png);
    z-index: 10;
    box-sizing: border-box;
    transform: translateX(-50%);
}

.cntor-wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #d4a161;
}

.basket-cntor .total {
    position: relative;
    padding-left: 60px;
}

.basket-cntor .check-box {
    position: absolute;
    left: 0;
    top: 50%;
    width: 49px;
    height: 46px;
    /* background-image: url(~@/assets/images/btn-basket-all.png); */
    background-image: url(~@/assets/images/icon-off.png);
    transform: translateY(-50%);
}

.basket-cntor .check-box.act {
    width: 65px;
    height: 61px;
    background-image: url(~@/assets/images/btn-basket-all-act.png);
}

.basket-cntor .total p {
    display: inline-block;
}

.basket-cntor .sale-detail {
    display: inline-block;
    width: 148px;
    height: 38px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/tag-down.png);
    vertical-align: middle;
}

.basket-cntor .u-btn.primary {
    position: relative;
    top: 20px;    
    width: 181px;
    height: 108px;
    background-image: url(~@/assets/images/btn-buy.png);
}

/* notice */
.notice{
  padding: 40px 0;
  text-align: center;
}

.notice h5{
  font-size: 40px;
  margin-bottom: 20px;
  color: #aa754f;
}

.notice a{
  color: #ad7239;
}
</style>



// WEBPACK FOOTER //
// src/views/basket.vue